import { Form, Select } from "antd";
import { useEffect, useState } from "react";
import { useInfoUser } from "../../store/UserStore";

const { Option } = Select;

const AuthorityConfiguration = ({ initialValues, authorityOptions, projectManager, isMobile }) => {
  const [projectAuthorityList, setProjectAuthorityList] = useState([]);
  const { user, languageMap } = useInfoUser();

  const AUTHORITY_CONFIG = {
    PROJECT: {
      ID: "M100200",
      LABEL: languageMap?.["project.management.config.project"] ?? "Project",
    },
    TASK: {
      ID: "M100300",
      LABEL: languageMap?.["project.management.config.task"] ?? "Task",
    },
    PROJECT_MANAGEMENT: {
      ID: "M100100",
      LABEL:
        languageMap?.["project.management.config.management"] ??
        "Project Management",
    },
  };

  useEffect(() => {
    if (initialValues?.type === "UPDATED") {
      const updatedProjectAuthorityRequest = Object.values(
        AUTHORITY_CONFIG
      ).map((configItem) => {
        const projectAuthority = initialValues.projectAuthorityRequest.find(
          (item) => item.authorityId === configItem.ID
        );
        return {
          ...projectAuthority,
          label: configItem.LABEL,
        };
      });
      setProjectAuthorityList(updatedProjectAuthorityRequest);
    } else {
      setProjectAuthorityList([
        {
          label: AUTHORITY_CONFIG.PROJECT.LABEL,
          authorityId: AUTHORITY_CONFIG.PROJECT.ID,
          queryCode: authorityOptions[authorityOptions.length - 1].code,
          inputCode: authorityOptions[authorityOptions.length - 1].code,
          modificationCode: authorityOptions[authorityOptions.length - 1].code,
          deletionCode: authorityOptions[authorityOptions.length - 1].code,
        },
        {
          label: AUTHORITY_CONFIG.TASK.LABEL,
          authorityId: AUTHORITY_CONFIG.TASK.ID,
          queryCode: authorityOptions[authorityOptions.length - 1].code,
          inputCode: authorityOptions[0].code,
          modificationCode: authorityOptions[0].code,
          deletionCode: authorityOptions[0].code,
        },
        {
          label: AUTHORITY_CONFIG.PROJECT_MANAGEMENT.LABEL,
          authorityId: AUTHORITY_CONFIG.PROJECT_MANAGEMENT.ID,
          queryCode: authorityOptions[authorityOptions.length - 1].code,
          inputCode: authorityOptions[0].code,
          modificationCode: authorityOptions[0].code,
          deletionCode: authorityOptions[0].code,
        },
      ]);
    }
  }, [initialValues]);

  const handleAdd = (item) => {
    const isUpdated = initialValues?.type === "UPDATED";
    const isProjectManager = projectManager?.userCode === user?.userCode;
    const authorityIds = [
      AUTHORITY_CONFIG.PROJECT.ID,
      AUTHORITY_CONFIG.TASK.ID,
      AUTHORITY_CONFIG.PROJECT_MANAGEMENT.ID,
    ];

    if (isUpdated) {

      if (isProjectManager) {
        return item.authorityId === AUTHORITY_CONFIG.PROJECT.ID;
      }
      return authorityIds.includes(item.authorityId);
    } else {
      return item.authorityId === AUTHORITY_CONFIG.PROJECT.ID;
    }
  };

  return (
    <div className="authority-config" style={{ paddingBottom: isMobile ? "80px" : "0"  }}>
      {projectAuthorityList.map((item, index) => (
        <div key={index}>
          <Form.Item
            className="pb-1 mb-1"
            name={["projectAuthorityRequest", index, "authorityId"]}
            initialValue={item.authorityId}
          >
            <span className="font-bold">{item.label}</span>
          </Form.Item>
          <div className="authority flex justify-between items-center my-1">
            <div className="rule-text-label">
              {languageMap?.["project.management.config.read"] ?? "Read:"}
            </div>
            <Form.Item
              name={["projectAuthorityRequest", index, "queryCode"]}
              initialValue={item.queryCode}
              noStyle
            >
              <Select
                placeholder="select authority"
                className="authority-select"
                disabled={handleAdd(item)}
              >
                {authorityOptions.map((authority) => (
                  <Option value={authority.code} key={authority.code} >
                    {languageMap?.[
                      `project.management.config.authority.${authority.enName.toLowerCase().replace(" ", "_")}`
                    ] ?? authority.enName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="authority flex justify-between items-center my-1">
            <div className="rule-text-label">
              {languageMap?.["project.management.config.create"] ?? "Create:"}
            </div>
            <Form.Item
              name={["projectAuthorityRequest", index, "inputCode"]}
              initialValue={item.inputCode}
              noStyle
            >
              <Select
                placeholder="select authority"
                className="authority-select"
                disabled={handleAdd(item)}
              >
                {authorityOptions.map((authority) => (
                  <Option value={authority.code} key={authority.code}>
                    {languageMap?.[
                      `project.management.config.authority.${authority.enName.toLowerCase().replace(" ", "_")}`
                    ] ?? authority.enName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="authority flex justify-between items-center my-1">
            <div className="rule-text-label">
              {languageMap?.["project.management.config.update"] ?? "Update:"}
            </div>
            <Form.Item
              name={["projectAuthorityRequest", index, "modificationCode"]}
              initialValue={item.modificationCode}
              noStyle
            >
              <Select
                placeholder="select authority"
                className="authority-select"
                disabled={handleAdd(item)}
              >
                {authorityOptions.map((authority) => (
                  <Option value={authority.code} key={authority.code}>
                    {languageMap?.[
                      `project.management.config.authority.${authority.enName.toLowerCase().replace(" ", "_")}`
                    ] ?? authority.enName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="authority flex justify-between items-center my-1">
            <div className="rule-text-label">
              {languageMap?.["project.management.config.delete"] ?? "Delete:"}
            </div>
            <Form.Item
              name={["projectAuthorityRequest", index, "deletionCode"]}
              initialValue={item.deletionCode}
              noStyle
            >
              <Select
                placeholder="select authority"
                className="authority-select"
                disabled={handleAdd(item)}
              >
                {authorityOptions.map((authority) => (
                  <Option value={authority.code} key={authority.code} >
                    {languageMap?.[
                      `project.management.config.authority.${authority.enName.toLowerCase().replace(" ", "_")}`
                    ] ?? authority.enName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>
      ))}
    </div>
  );
};

export { AuthorityConfiguration };
